/*
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-09-07 16:16:40
 */


import { useStore } from '../store'
import HttpClient, { HttpClientConfig } from 'axios-mapper'
import networkConfig from '@/config/default/net.config'
import { ElMessage } from 'element-plus'
import router from '@/router'
import { UserActionTypes } from '../store/modules/user/action-types'
import {getToken,removeToken} from './cookies'
import i18n from "@/locales/index";
const _t = i18n.global.t;
const store = useStore()
let isstatus401 = false
const https = (hasToken: Boolean = true) => {
  const config: HttpClientConfig = {
    baseURL: networkConfig.host,
    headers: {
      // Authorization: hasToken ? useStore().state.user.token : ''
      Authorization: hasToken ? getToken() : ''
    }
  }
  const resconfig = new HttpClient(config)
  resconfig.httpClient.interceptors.response.use(
    function (response) {
      // console.log(response, '响应拦截')
      return response;
    }, function (error) {
      // console.log(store.dispatch(UserActionTypes.ACTION_RESET_TOKEN, undefined), '错误拦截')
      if (error.response.status == 401) {
        removeToken()
        useStore().state.user.roles = []
        if (!isstatus401) {
          isstatus401 = true
          ElMessage({
            type:'error',
            message: _t('login.account_expired'),
            duration: 2000,
            onClose:()=>{
              router.push('/login')
              isstatus401 = false
            }
          })
        }
      }
      return Promise.reject(error);
    }
  )
  return resconfig
}

export default https
